const f = {
  color: {
    dot1: "#abb9c7ff",
    dot2: "#c8d3deff",
    dot3: "#f1f3f5ff"
  }
};
export {
  f as typingDots
};
